<template>
  <div>
   <v-card>
    <v-card-title>
         Viewer Action
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
       <v-chip class="mb-2">
         <span>Execute</span><v-btn color="primary" icon @click="executeAction" :loading="loading"> <v-icon>mdi-play</v-icon></v-btn>
       </v-chip >
        <div style="color:red" v-if="error">{{ error }}</div>
        <div class="text-disabled caption " v-if="error"> <i class="fa-solid fa-circle-exclamation"></i> Our AI assistant is continuously improving, and we appreciate your patience as we enhance its capabilities.</div>
    </v-card-text>
   </v-card>
  </div>
</template>

<script>
import { log, warn, error } from '@/utils/debugLogger';
export default {
props:['message'],
mounted(){
    document.VIEWER_MESSAGE=this.message;
    log('chatbot-message-viewer-action', 'Viewer Action message', this.message);
},
data(){
    return {
        loading:false,
        error:null
    }
},
methods:{
    executeAction() {

        this.loading = true;
        this.error = null;
        setTimeout(() => {
            try {
                
                const reactWithViewer1 = new Function("store", this.message.action);
                // this.reactWithViewer(this.$store.state,{tagName:'BD-501185-1"-EA3DY'})
                reactWithViewer1(this.$store.state)
                document.reactWithViewer1 = reactWithViewer1;
                log('chatbot-message-viewer-action', 'reactWithViewer1', reactWithViewer1);
                this.loading = false;
            } catch (error) {
                this.loading = false;
                this.error = "Error: Could not execute the current action, please retry with other prompt"
            }
        },300);



    }


}
}
</script>

<style>

</style>